import CONTACT from "./contact.constants";
import RANGEPDF from "./rangepdf.constants";

const ROUTES = {
  language: '/',
  prefix: '/:lang',
  home: '/',
  electric: '/electric',
  cars: '/cars',
  carsDetail: '/cars/:slug',
  stories: '/stories',
  storiesDetail: '/stories/:slug',
  contact: '/contact',
  contactDetail: '/contact/:source',
  quote: `/contact/${CONTACT.quote}`,
  testdrive: `/contact/${CONTACT.testdrive}`,
  tradein: `/contact/${CONTACT.tradein}`,
  rangepdf: '/the-EV2-range-PDF',
  rangepdfDetail: '/the-EV2-range-PDF/:source',
  rangepdfHints: `/the-EV2-range-PDF/${RANGEPDF.hints}`,
  rangepdfTestdrive: `/the-EV2-range-PDF/${RANGEPDF.testdrive}`,
  rangepdfCode: `/the-EV2-range-PDF/${RANGEPDF.code}`,
  pages: '/pages',
  pagesDetail: '/pages/:slug',
  notfound: '/notfound'
};

export default ROUTES;
